// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointFilterValuesFromJSON, DatapointFilterValuesToJSON, } from './';
export function DatapointsFiltersResponseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'filters': !exists(json, 'filters') ? undefined : json['filters'].map(DatapointFilterValuesFromJSON),
    };
}
export function DatapointsFiltersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'filters': value.filters === undefined ? undefined : value.filters.map(DatapointFilterValuesToJSON),
    };
}
